import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { faAngleLeft, faAngleRight, faCircle, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";   //faCircle,
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AllTrendingProductsPagination, AscendingOrder, DecendingOrder, GetAndCreateTrendingProducts } from "../../../../services/ProductService/AllProductList/AllProductServices";
import TableActionPopUp from "./TableActionPopUp";
import AllServicesData from "../../../../utils/AllServicesData/AllServicesData";

export default function AllTrendingServicesTable({ onSelectColumns, onSelectedIds, onSuccess, onColumnSearch, onRefresh, onPageSize, onReturnPageSize }) {

    const [allTrendingProductsList, setAllTrendingProductsList] = useState([]);
    const [filteredTrendingProductsList, setFilteredTrendingProductsList] = useState([]);
    const [visibleColumns, setVisibleColumns] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
    const [searchTerms, setSearchTerms] = useState({});
    const navigate = useNavigate();
    const popupRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [pageCount, setPageCount] = useState(1);
    const [nextPageLink, setNextPageLink] = useState(null);
    const [previousPageLink, setPreviousPageLink] = useState(null);
    const [pageSize, setPageSize] = useState(20);
    const columnKeyMap = {
        'Service Id': 's_id',
        'Status': 'status',
        'Service Name': 'name',
        'Service Category': 'category_p',
        'Service HSN Code': 's_hsn_code_no',
        // 'Assigned To': 'assigned_to',
        'Verified': 'is_verified',
        'Service Added By': 's_add_by',
        'Service Added Date': 's_add_date',
        'Service Added Time': 's_add_time',
        'Service Last Modified By': 's_last_modified_by',
        'Service Last Modified Date': 's_last_add_date',
        'Service Last Modified Time': 's_last_add_time',
        'Service Owner': 's_owner',
        'Service Recommended for': 's_recommended_for',
        'Tags': 'tag',
        'Next Step': 'next_step',
        'Default Unit': 'default_unit',
        'Indicative Min Price': 'indicative_min_price',
        'Indicative Max Price': 'indicative_max_price',
        'Service Price': 's_price',
        'Service Old Price': 's_old_price',
        'Service Discount': 's_discount',
        // 'Service Images': 'product_images',
        'Production Capacity': 'production_capacity',
        'Production Capacity Unit': 'production_capacity_unit',
        'Present Stock Status': 'present_stock_status',
        'Production Lead Time': 'production_lead_time',
        'Minimum Order Quantity': 'min_order_quantity',
        'Minimum Order Quantity Unit': 'min_order_quantity_unit',
        // 'Attached Service Certificates': 'attached_product_certificates',
        'Service Life': 's_life',
        'Service LifeSpan': 's_lifespan',
        'Service Certifications': 's_certification',
        'Service Description': 's_description',
        'Service Varients': 's_varient'
    };
    const defaultVisibleColumns = [
        'Service Id',
        'Status',
        'Service Name',
        'Service Category',
        'Service HSN Code',
        'Assigned To',
        'Tags'
    ];

    const getAllTrendingProductsList = async () => {
        setLoading(true);
        try {
            // const response = await GetAndCreateTrendingProducts('GET', {});
            // setAllTrendingProductsList(response.data.results);
            // setFilteredTrendingProductsList(response.data.results);
            // setNextPageLink(response.data.links.next)
            // setPreviousPageLink(response.data.links.previous)
            setAllTrendingProductsList(AllServicesData.results)
            setFilteredTrendingProductsList(AllServicesData.results)
        } catch (error) {
            console.error("Error fetching product list:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleClickOutside = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setShowPopup(false);
        }
    };

    const handleIconClick = (id, event) => {
        event.stopPropagation();
        const rect = event.currentTarget.getBoundingClientRect(); // Get icon's position

        setPopupPosition({
            x: rect.left - 100, // Adjust the left position to be on the left side of the icon
            y: rect.top + 10 + window.scrollY // Adjust for any scroll position
        });

        setSelectedId(id);
        setShowPopup(true);
    };

    const handleProductClick = (id) => {
        if (id) {
            navigate(`/admin-dashboard/services/view-service/${id}`);
        }
    }

    const handleSelectAll = () => {
        if (selectedIds.length === filteredTrendingProductsList.length) {
            // If all filtered items are selected, deselect all
            setSelectedIds([]);
        } else {
            // Select all visible (filtered) products
            setSelectedIds(filteredTrendingProductsList.map(item => item.p_id));
        }
    };

    // ✅ Pass selected Ids to parent and close modal
    if (selectedIds.length >= 0) {
        if (typeof onSelectedIds === "function") {
            onSelectedIds(selectedIds); // Pass data up
        }
    };

    const handleSelectItem = (id) => {
        setSelectedIds((prevSelectedIds) =>
            prevSelectedIds.includes(id)
                ? prevSelectedIds.filter((selectedId) => selectedId !== id) // Deselect
                : [...prevSelectedIds, id] // Select
        );
    };

    const handleSearch = (col, value) => {
        const updatedSearchTerms = { ...searchTerms, [col]: value };
        setSearchTerms(updatedSearchTerms);

        // Filter logic
        const filtered = allTrendingProductsList.filter(item =>
            visibleColumns.every(col => {
                const searchTerm = updatedSearchTerms[col]?.toString().toLowerCase();
                const value = item[columnKeyMap[col]]?.toString().toLowerCase();
                return !searchTerm || (value && value.includes(searchTerm));
            })
        );
        setFilteredTrendingProductsList(filtered);
    };

    const onSearchColumn = (input) => {  
        // Reset to full list if input is empty
        const trimmedInput = input.trim();
        if (trimmedInput.length === 1) {
            setFilteredTrendingProductsList(allTrendingProductsList);
            setVisibleColumns(defaultVisibleColumns);
            return;
        }
    
        // Find matching columns dynamically (case-insensitive partial match)
        const matchedColumns = Object.keys(columnKeyMap).filter(col =>
            col.toLowerCase().includes(input.toLowerCase())
        );
    
        if (matchedColumns.length === 0) {
            console.warn(`No columns match "${input}"`);
            return;
        }
    
        // If multiple columns match, let the user pick or show all matches

        const filtered = allTrendingProductsList.map(item => {
            let filteredData = { p_id: item.p_id }; // Always include Product ID
        
            matchedColumns.forEach(column => {
                const columnKey = columnKeyMap[column];
                filteredData[columnKey] = item[columnKey] || "-"; // Add all matched columns
            });
        
            return filteredData;
        });
        
        setFilteredTrendingProductsList(filtered);
        setVisibleColumns(["Product Id", ...matchedColumns]); // Show all matching columns
                
    };

    const [columnSortOrder, setColumnSortOrder] = useState({}); // Track sorting order per column

    const handleOrder = (col) => {
        const fieldName = columnKeyMap[col]; 
        const newOrder = columnSortOrder[col] === "desc" ? "asc" : "desc";
        
        const sortedList = [...filteredTrendingProductsList].sort((a, b) => {
            const valueA = a[fieldName]?.toString().toLowerCase() || "";
            const valueB = b[fieldName]?.toString().toLowerCase() || "";
    
            if (!isNaN(valueA) && !isNaN(valueB)) { 
                // Numeric sorting
                return newOrder === "asc" ? valueA - valueB : valueB - valueA;
            } else {
                // String sorting
                return newOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            }
        });
    
        setFilteredTrendingProductsList(sortedList);
        setColumnSortOrder((prev) => ({ ...prev, [col]: newOrder }));
    };

    const handleChangePage = async (condition) => {
        if (condition === 'previous') {
            if (previousPageLink) {
                const params = { page: pageCount - 1 }
                try {
                    const response = await AllTrendingProductsPagination("GET", { params });
                    setAllTrendingProductsList(response.data.results);
                    setFilteredTrendingProductsList(response.data.results);
                    setNextPageLink(response.data.links.next)
                    setPreviousPageLink(response.data.links.previous)
                } catch (error) {
                    console.error(error);
                }
                setPageCount(pageCount - 1)
            }
        } else if (condition === 'next') {
            if (nextPageLink) {
                const params = { page: pageCount + 1 }
                try {
                    const response = await AllTrendingProductsPagination("GET", { params });
                    setAllTrendingProductsList(response.data.results);
                    setFilteredTrendingProductsList(response.data.results);
                    setNextPageLink(response.data.links.next)
                    setPreviousPageLink(response.data.links.previous)
                } catch (error) {
                    console.error(error);
                }
                setPageCount(pageCount + 1)
            }
        }
    }

     useEffect(() => {
            if (onPageSize) {
                setPageSize(onPageSize)
                const fetchProducts = async () => {
                    const params = { page_size: onPageSize };
                    try {
                        const response = await AllTrendingProductsPagination("GET", { params });
                        setAllTrendingProductsList(response.data.results);
                        setFilteredTrendingProductsList(response.data.results);
                        setNextPageLink(response.data.links.next);
                        setPreviousPageLink(response.data.links.previous);
                    } catch (error) {
                        console.error("Error fetching paginated products:", error);
                    }
                };
    
                fetchProducts();
                setPageCount(1); // Prevents negative page count
            }
        }, [onPageSize]); // Added dependency on `onPageSize`

        const handlePageSize = (value) => {
            setPageSize(Number(value))
            const fetchProducts = async () => {
                const params = { page_size: onPageSize };
                try {
                    const response = await AllTrendingProductsPagination("GET", { params });
                    setAllTrendingProductsList(response.data.results);
                    setFilteredTrendingProductsList(response.data.results);
                    setNextPageLink(response.data.links.next);
                    setPreviousPageLink(response.data.links.previous);
                } catch (error) {
                    console.error("Error fetching paginated products:", error);
                }
            };

            fetchProducts();
            setPageCount(1); // Prevents negative page count setPageSize(Number(value))
                    if (pageSize) {
                        const fetchProducts = async () => {
                            const params = { page_size: Number(value) };
                            try {
                                const response = await AllTrendingProductsPagination("GET", { params });
                                setAllTrendingProductsList(response.data.results);
                                setFilteredTrendingProductsList(response.data.results);
                                setNextPageLink(response.data.links.next);
                                setPreviousPageLink(response.data.links.previous);
                            } catch (error) {
                                console.error("Error fetching paginated products:", error);
                            }
                        };
            
                        fetchProducts();
                        setPageCount(1); // Prevents negative page 
                        onReturnPageSize(Number(value))
                    }
        }
        
    useEffect(() => {
        getAllTrendingProductsList();
        setPageSize(20)
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        getAllTrendingProductsList();
        setPageCount(1)
        setNextPageLink(null)
        setPreviousPageLink(null)
    }, [onRefresh]);


    useEffect(() => {
        if (onSelectColumns && onSelectColumns.length > 0) {
            setVisibleColumns(onSelectColumns);
        } else {
            setVisibleColumns(defaultVisibleColumns);
        }
    }, [onSelectColumns]);

    useEffect(() => {
        if (onSuccess) {
            getAllTrendingProductsList()
            setSelectedIds([])
        }
        setPageCount(1)
        setNextPageLink(null)
        setPreviousPageLink(null)
    }, [onSuccess])

    useEffect(() => {
        if (onColumnSearch && typeof onColumnSearch === "string") {
            onSearchColumn(onColumnSearch);
        }

    }, [onColumnSearch]);

    return (
        <>
            {allTrendingProductsList.length === 0 ? (<div className="text-center">No Trending Products...</div>) : (
                <div className="overflow-scroll mx-7">
                <table className="min-w-full table-auto border-collapse">
                    <thead className="border border-gray-300 bg-gray-100">
                        <tr className="">
                            <th>
                                <input
                                    type="checkbox"
                                    className="scale-125 border border-gray-300"
                                    checked={filteredTrendingProductsList.length > 0 && selectedIds.length === filteredTrendingProductsList.length}
                                    onChange={handleSelectAll}
                                />
                            </th>
                            {visibleColumns.map((col) => (
                                <th key={col} className="w-fit text-center border border-gray-300 px-4 py-2 text-gray-600 whitespace-nowrap ">
                                    {col} &nbsp; <span
                                        key={col}
                                        className="px-2 py-0.5 font-bold border bg-white rounded-lg hover:bg-gray-300 cursor-pointer"
                                        onClick={() => handleOrder(col)}>{columnSortOrder[col] === 'desc' ? "\u2191" : "\u2193"}</span>
                                </th>
                            ))}
                            <th className="w-fit text-center border border-gray-300 px-4 py-2 text-gray-600">Actions</th>
                        </tr>
                        <tr className="bg-[#F7F7F7]">
                            <td className="border border-gray-300 px-4 py-2"></td>
                            {visibleColumns.map((col) => (
                                <td key={`search-${col}`} className="px-4 py-2 border border-gray-300 w-full">
                                    <input
                                        type="text"
                                        className="border border-gray-300 rounded-2xl px-3 outline-none"
                                        placeholder={`Search ${col}...`}
                                        onChange={(e) => handleSearch(col, e.target.value)}
                                    />
                                </td>
                            ))}
                            <td className="px-4 py-2 border border-gray-300"></td>
                        </tr>
                    </thead>
                    <tbody className="text-[14px] text-[#333]">
                        {loading ? (
                            <tr>
                                <td colSpan={visibleColumns.length + 2} className="text-center py-4 text-xl font-bold text-gray-500">
                                    Fetching Data...
                                </td>
                            </tr>
                        ) : (
                            filteredTrendingProductsList.map((item) => (
                                <tr key={item.s_id} className="hover:bg-gray-100">
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        <input
                                            type="checkbox"
                                            className="scale-125 border border-gray-300 cursor-pointer"
                                            checked={selectedIds.includes(item.s_id)}
                                            onChange={() => handleSelectItem(item.s_id)}
                                        />
                                    </td>
                                    {visibleColumns.map((col) => (
                                        <td key={col} className="border border-gray-300 px-4 py-2 cursor-pointer text-center"
                                            onClick={() => handleProductClick(item.s_id)}>
                                            {col === "Verified"
                                                ? item[columnKeyMap[col]] === true
                                                ? <div className="flex justify-center"><p className="text-green-600 px-3 py-1 bg-green-200 w-fit rounded-lg">Verified</p></div>
                                                : <div className="flex justify-center"><p className="text-red-600 px-3 py-1 bg-red-200 w-fit rounded-lg">Not Verified</p></div>
                                                : col === "Status"
                                                    ? item[columnKeyMap[col]] === "active"
                                                        ? <div className="flex justify-center"><div className="text-green-600 px-3 py-1 bg-green-200 w-fit rounded-lg flex items-center gap-1"><p className="text-xs"><FontAwesomeIcon icon={faCircle} /></p> Active</div></div>                                                                                         : <div className="flex justify-center"><div className="text-red-600 px-3 py-1 bg-red-200 w-fit rounded-lg flex items-center gap-1"><p className="text-xs"><FontAwesomeIcon icon={faCircle} /></p> Deactive</div></div>
                                                    : (item[columnKeyMap[col]] || "-")}
                                        </td>
                                    ))}
                                    <td className="border border-gray-300 px-4 py-2 text-center">
                                        <span
                                            className="cursor-pointer"
                                            onClick={(event) => handleIconClick(item.s_id, event)}
                                        >
                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
                </div>
            )}
            {/* Pagination */}
            <div className="flex items-center justify-center mt-5">
                <div className="flex items-center gap-6">
                    <button className={`text-white px-4 py-1 rounded-lg ${previousPageLink ? "bg-sky-500 hover:bg-sky-300" : "bg-gray-500 opacity-50 cursor-not-allowed"}`}
                        disabled={!previousPageLink}
                        onClick={() => handleChangePage('previous')}>
                        <FontAwesomeIcon icon={faAngleLeft} />
                    </button>
                    <p className="font-bold">{pageCount}</p>
                    <button className={`text-white px-4 py-1 rounded-lg ${nextPageLink ? "bg-sky-500 hover:bg-sky-300" : "bg-gray-500 opacity-50 cursor-not-allowed"}`}
                        disabled={!nextPageLink}
                        onClick={() => handleChangePage('next')}>
                        <FontAwesomeIcon icon={faAngleRight} />
                    </button>
                </div>
            </div>
            {/* Pagination */}
            <div className="border border-gray-300 border-collapse rounded-lg text-gray-500 flex items-center w-fit mx-7">
                <div className={`py-1 px-2 cursor-pointer border-r border-gray-300 ${pageSize === 20 ? 'bg-blue-600 text-white rounded-l-lg' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>20</div>
                <div className={`py-1 px-2 cursor-pointer border-r border-gray-300 ${pageSize === 100 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>100</div>
                <div className={`py-1 px-2 cursor-pointer border-r border-gray-300 ${pageSize === 500 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>500</div>
                <div className={`py-1 px-2 cursor-pointer border-r border-gray-300 ${pageSize === 2500 ? 'bg-blue-600 text-white' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>2500</div>
                <div className={`py-1 px-2 cursor-pointer ${pageSize === 5000 ? 'bg-blue-600 text-white rounded-r-lg' : ''}`} onClick={(e) => handlePageSize(e.currentTarget.textContent)}>5000</div>
            </div>
            {showPopup && (
                <div ref={popupRef} style={{ position: "absolute", top: `${popupPosition.y}px`, left: `${popupPosition.x}px`, zIndex: 10 }}>
                    <TableActionPopUp ProductId={selectedId} onSuccess={() => setShowPopup(false)} />
                </div>)}
        </>
    )
}
